import React from 'react';
import Navbar from '../../Navbar/Navbar';
import './Projects.css';
import project1 from '../../../images/projects/creative-agency.png';
import project2 from '../../../images/projects/doctors-portal.png';
import project3 from '../../../images/projects/volunteer-network.png';
import project4 from '../../../images/projects/travel-guru.png';
import project5 from '../../../images/projects/e-school.png';
import project6 from '../../../images/projects/hot-gadgets.png';

const Projects = () => {
    return (
        <div className="Projects">
            <div className="container py-5">
                <div className="header text-center">
                    <h2>MY LATEST <span>PROJECTS</span></h2>
                    {/* <p>An eye for detail makes my works excellent</p> */}
                    <div className="wrapper">
                        <div className="divider div-transparent div-dot"></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <img className="card-img-top" src={project1} alt=""/>
                            <div className="card-body">
                                <h4 className="card-title">Creative Agency</h4>
                                <p className="card-text"></p>
                                <div className="technology mb-4"><span>React</span> <span>React Router</span> <span>Node.js</span> <span>Express.js</span> <span>MongoDB</span> <span>Bootstrap</span> <span>Firebase</span> <span>Heroku</span></div>
                                <a href="https://github.com/Noor-Muhammadd/agency" target="_blank" rel="noopener noreferrer" className="mr-3"><i className="fab fa-github"></i></a>
                                <a href="https://create-agency-561f9.web.app/" target="_blank" rel="noopener noreferrer"><i className="fas fa-external-link-alt"></i></a>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <img className="card-img-top" src={project2} alt=""/>
                            <div className="card-body">
                                <h4 className="card-title">Doctor's Portal</h4>
                                <p className="card-text">Single page web application with the dashboard. A patient can book an appointment for a specific date and time. A doctor can see appointments for a specific date.</p>
                                <div className="technology mb-4"><span>React</span> <span>React Router</span> <span>Node.js</span> <span>Express.js</span> <span>MongoDB</span> <span>Bootstrap</span> <span>Firebase</span> <span>Heroku</span></div>
                                <a href="https://github.com/tayab-pabel/doctors-portal-client" target="_blank" rel="noopener noreferrer" className="mr-3"><i className="fab fa-github"></i></a>
                                <a href="https://doctors-portal-tp.web.app/" target="_blank" rel="noopener noreferrer"><i className="fas fa-external-link-alt"></i></a>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <img className="card-img-top" src={project3} alt=""/>
                            <div className="card-body">
                                <h4 className="card-title">Volunteer Network</h4>
                                <p className="card-text"></p>
                                <div className="technology mb-4"><span>React</span> <span>React Router</span> <span>Node.js</span> <span>Express.js</span> <span>MongoDB</span> <span>Bootstrap</span> <span>Firebase</span> <span>Heroku</span></div>
                                <a href="https://github.com/Noor-Muhammadd/volunteer" target="_blank" rel="noopener noreferrer" className="mr-3"><i className="fab fa-github"></i></a>
                                <a href="https://volunteer-a1853.web.app/" target="_blank" rel="noopener noreferrer"><i className="fas fa-external-link-alt"></i></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <img className="card-img-top" src={project4} alt=""/>
                            <div className="card-body">
                                <h4 className="card-title">Travel Guru</h4>
                                <p className="card-text"></p>
                                <div className="technology mb-4"><span>React</span> <span>React Router</span> <span>Bootstrap</span><span>Firebase</span></div>
                                <a href="https://github.com/Noor-Muhammadd/travel-guru2" target="_blank" rel="noopener noreferrer" className="mr-3"><i className="fab fa-github"></i></a>
                                <a href="https://my-first-project-32f1f.web.app/" target="_blank" rel="noopener noreferrer"><i className="fas fa-external-link-alt"></i></a>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <img className="card-img-top" src={project5} alt=""/>
                            <div className="card-body">
                                <h4 className="card-title">E-School</h4>
                                <p className="card-text">A static online learning website with responsive layouts for every kind of device. The review section builds with a carousel slider.</p>
                                <div className="technology mb-4"><span>Bootstrap</span> <span>HTML</span> <span>CSS</span> <span>Figma</span> <span>GitHub</span></div>
                                <a href="https://github.com/tayab-pabel/e-school" target="_blank" rel="noopener noreferrer" className="mr-3"><i className="fab fa-github"></i></a>
                                <a href="https://tayab-pabel.github.io/e-school/" target="_blank" rel="noopener noreferrer"><i className="fas fa-external-link-alt"></i></a>
                            </div>
                        </div>
                    </div> */}
                    {/* <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <img className="card-img-top" src={project6} alt=""/>
                            <div className="card-body">
                                <h5 className="card-title">Hot Gadgets</h5>
                                <p className="card-text">A static e-commerce website with responsive layouts for every kind of device. The header section builds with a carousel slider.</p>
                                <div className="technology mb-4"><span>Bootstrap</span> <span>HTML</span> <span>CSS</span> <span>Figma</span> <span>GitHub</span></div>
                                <a href="https://github.com/tayab-pabel/hot-gadgets" target="_blank" rel="noopener noreferrer" className="mr-3"><i className="fab fa-github"></i></a>
                                <a href="https://tayab-pabel.github.io/hot-gadgets/" target="_blank" rel="noopener noreferrer"><i className="fas fa-external-link-alt"></i></a>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default Projects;